import { FC, useState } from "react";
import * as Sentry from "@sentry/react";
import { InlineErrorView } from "@/components/InlineErrorView";

export const withErrorBoundary =
  <T,>(WrappedComponent: FC<T>): FC<T> =>
  (props: T) => {
    const [_, noop] = useState(null);

    return (
      <Sentry.ErrorBoundary
        fallback={(props) => <InlineErrorView {...props} />}
        onReset={() => noop(null)}
      >
        <WrappedComponent {...props} _={_} />
      </Sentry.ErrorBoundary>
    );
  };
